import { customAlphabet } from 'nanoid';
const nanoid =  customAlphabet('1234567890abcdef', 32);

const storage = window.localStorage;
const PREFIX = '';

const saveSession = (id, data) => {
  storage.setItem(`${PREFIX}${id}`, window.btoa(JSON.stringify(data)));
};

export const getSession = (id) => {
  try {
    return JSON.parse(window.atob(storage.getItem(`${PREFIX}${id}`)));
  } catch (error) {
    return;
  }
};

export const removeSession = (id) => {
  storage.removeItem(`${PREFIX}${id}`);
};

export const closeSession = (id) => {
  const session = getSession(id)
  saveSession(id, {
    ...session,
    isClosed: true
  });
};

export const createSession = (goodsNoList = [], { orderTempSeq, cartIds, goodsCategory } = {}) => {
  const id = nanoid();

  if (!goodsNoList?.length) {
    console.log('주문상품 정보가 없습니다.');
    return;
  }

  saveSession(id, {
    goodsNoList,
    orderTempSeq,
    cartIds,
    isClosed: false,
    goodsCategory,
  });

  return id;
};
